module.exports = __webpack_public_path__ + "media/images/icons/edit-e55beb07b4eae891db4eac4b774a2e29.svg";